import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";


export default {
    namespaced: true,
    state: {
        salaryReports: [],
        salaryAndScheduleDataToPrint: null,
    },
    mutations: {
        addOrUpdateSalaryReport(state, newData) {
            if (!newData) return;
            const targetSalaryReportIndex = state.salaryReports.findIndex(salaryReport => salaryReport.id === newData.id);
            if (targetSalaryReportIndex === -1) state.salaryReports.push(newData);
            else state.salaryReports[targetSalaryReportIndex] = newData;
        },
        addOrUpdateSalaryReports(state, newData) {
            for (const element of newData) {
                const targetSalaryReportIndex = state.salaryReports.findIndex(salaryReport => salaryReport.id === element.id);
                if (targetSalaryReportIndex === -1) state.salaryReports.push(element);
                else state.salaryReports[targetSalaryReportIndex] = element;
            }
        },
        setSalaryReports(state, newData) {
            state.salaryReports = newData;
        },
        setSalaryAndScheduleDataToPrint(state, newData) {
            state.salaryAndScheduleDataToPrint = {
                staff: newData["staff_data"],
                schedules: newData["schedule_data"],
                salary_reports: newData["salary_report_data"],
                payouts: newData["payout_data"],
                accruals: newData["accrual_data"],
                date_from: newData["date_from"],
                date_to: newData["date_to"],
            }
        },
    },
    actions: {
        async getSalaryReports({commit, rootState}, date) {
            const {personalData, company} = rootState;
            const url = `${URLS.MODEL.SALARY_REPORT.SALARY_REPORTS_URL}?date=${date}`;
            const options = {
                method: "GET",
                credentials: "include",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
            };
            const successfulHandler = (data) => {
                commit("setSalaryReports", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async getSalaryReportsToPrint({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {staff, dateTo, dateFrom} = params;
            const url = URLS.MODEL.SALARY_REPORT.SALARY_REPORTS_URL;
            const options = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    staff: staff,
                    date_from: dateFrom,
                    date_to: dateTo,
                }),
            };
            const successfulHandler = (data) => {
                commit("setSalaryAndScheduleDataToPrint", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    }
};